import { createSlice } from "@reduxjs/toolkit";

const initialState = { procedimento: { parameters: [] } };

export const procedimentoSlice = createSlice({
  name: "procedimento",
  initialState,
  reducers: {
    filtrarProcedimento(state, action) {
      const { payload } = action;
      return { ...state, procedimento: { parameters: payload } };
    },
    resetProcedimento(state) {
      state.procedimento.parameters = [];
    },
  },
});

export const procedimentoAction = procedimentoSlice.actions;

export default procedimentoSlice.reducer;
